import { useMutation } from "@tanstack/react-query";
import { uploadStoryFile } from "Api/Mutations/Stories/uploadStoryFile";

type Props = {
  onSuccess?: (url: string) => void;
  onError?: () => void;
};

/** Uploads a short story video through our API to our blob storage and returns its public URL. */
export const useUploadStoryVideoMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: (file: File) => uploadStoryFile("video", file),
    onSuccess,
    onError,
  });
